import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DecimalPipe } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { BsModalService } from "ngx-bootstrap";

import { ApiService } from "../../../../../../projects/accounting/src/lib/services/api.service";
import { StorageService } from '../../../../../../projects/jv-common/src/lib/services/storage.service';

import { MessageBoxComponent, MessageBoxData, MessageBoxButton } from "../../../../../../projects/jv-ui/src/public_api";

import { Fee, FeeType, IDNameAddress } from '../../../../../../projects/accounting/src/public_api';
import { ApplicationEditorComponent } from './application-editor/application-editor.component';

export interface ApplicationData {
  fee: Fee;
  capitals: Array<IDNameAddress>;
}

interface ApiRecord {
  CapitalID: number;
  Name?: string;
  Address?: string;
  FeeID: number;
  Since: string;
  Last: string;
}

@Component({
  selector: 'fee-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.scss']
})
export class ApplicationComponent implements OnInit {

  private capitalLU = {};

  private capitals: Array<ApiRecord> = [];

  @Input() data: ApplicationData = this.storage.get("/configs/fees/application:input", null);

  loading = false;

  appliedConfig = {
    data: [],
    title: 'ĐANG ÁP DỤNG',
    txt: i => i.Address,

    columns: [
      {
        title: 'Đang áp dụng',
        class: 'text-left',
        html: i => this.html(i.Address),
        css: i => 'text-left',
      },
      {
        title: 'Thông tin',
        class: 'text-right',
        html: i => 'Tính từ <span class="text-primary">' + i.Since + '</span><br>' + (i.Last == null ? 'Chưa áp dụng' : 'Đã tính tới <span class="text-success">' + i.Last + '</span>'),
        css: i => 'text-right',
      },
      {
        title: '',
        html: function (i) {
          return '<i class="fa-close fa text-danger"></i>'
        },
        css: i => 'text-center text-info',
        click: i => this.remove(i),
      }
    ]
  };
  unAppliedConfig = {
    data: [],
    title: 'KHÔNG ÁP DỤNG',
    txt: i => i.Address,

    columns: [
      {
        title: 'Không áp dụng',
        class: 'text-left',
        html: i => this.html(i.Address),
        css: i => 'text-left',
      },
      {
        title: '',
        html: function (i) {
          return '<i class="fa-plus fa text-success"></i>'
        },
        css: i => 'text-center text-info',
        click: i => this.add(i)
      }
    ]
  };
  private timeLU = {
    Day: 'ngày',
    Month: 'tháng',
    Quarter: 'quý',
    Year: 'năm',
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private route: Router,
    private api: ApiService,
    private decima: DecimalPipe,
    private modal: BsModalService,
    private storage: StorageService
  ) {

  }

  ngOnInit() {

    if (this.data == null) this.back();

    this.data.capitals.forEach(i => {

      let obj: ApiRecord = {
        FeeID: this.data.fee.id,
        CapitalID: i.id,
        Name: i.name,
        Address: i.address,
        Since: null,
        Last: null
      };

      this.capitals.push(obj);
      this.capitalLU[i.id] = obj;
    });

    this.load();
  }

  back() {
    return this.route.navigate(['configs/fees']);
  }

  load() {

    this.loading = true;

    this.api.feeInfo(this.data.fee.id).subscribe(response => {
      if (response) {

        response.data.forEach(i => {
          this.capitalLU[i.CapitalID].Since = i.Since;
          this.capitalLU[i.CapitalID].Last = i.Last;
        });

        this.appliedConfig.data = this.capitals.filter(i => i.Since != null);
        this.unAppliedConfig.data = this.capitals.filter(i => i.Since == null);

        this.loading = false;

      }
    })
  }

  info() {
    switch (this.data.fee.type) {
      case FeeType.income: return (parseFloat(this.data.fee.data[0]) * 100) + '% tỷ lệ doanh thu';
      case FeeType.periodic:
        switch (this.data.fee.data[3]) {
          case 'Fixed': return this.decima.transform(this.data.fee.data[2], '1.0-3', 'en-US') + '/ ' + this.data.fee.data[0] + ' ' + this.timeLU[this.data.fee.data[1]];
          case 'M2': return this.decima.transform(this.data.fee.data[2], '1.0-3', 'en-US') + '/ m2/ ' + this.data.fee.data[0] + ' ' + this.timeLU[this.data.fee.data[1]];
        }
      case FeeType.oneTime:
        switch (this.data.fee.data[0]) {
          case 'Fee': return 'Phí';
          case 'Deposit': return 'Đặt cọc';
        }
    }

    return '';
  }

  html(address: string): string {
    let first = address.split(',')[0];
    return '<b>' + first + '</b><br><small>' + address.substr(first.length + 1) + '</small>';
  }

  add(record: ApiRecord) {

    let amountRequired = this.data.fee.type == FeeType.oneTime || this.data.fee.type == FeeType.unpredictable;

    this.modal
      .show(ApplicationEditorComponent, { class: amountRequired ? 'modal-lg' : 'modal-md', initialState: { data: { address: record.Address, type: this.data.fee.type } } })
      .content.commit.subscribe(data => {

        if (amountRequired) {

          let request = {
            FeeID: record.FeeID,
            CapitalID: record.CapitalID,
            Amount: data.amount,
            Date: data.date
          }

          this.loading = true;

          this.api.feeApply(request).subscribe(
            response => {
              if (response) {
                this.capitalLU[record.CapitalID].Since = this.capitalLU[record.CapitalID].Last = data.date;

                this.appliedConfig.data = this.capitals.filter(i => i.Since != null);
                this.unAppliedConfig.data = this.capitals.filter(i => i.Since == null);
              }

              this.loading = false;
            },

            error => {
              this.loading = false;
            }
          );
        }
        else {

          let request = {
            FeeID: record.FeeID,
            CapitalID: record.CapitalID,
            Since: data.date,
          };

          this.loading = true;

          this.api.feeAdd(request).subscribe(
            response => {

              if (response.succeed && response.data != null) {

                this.capitalLU[record.CapitalID].Since = response.data.Since;

                this.appliedConfig.data = this.capitals.filter(i => i.Since != null);
                this.unAppliedConfig.data = this.capitals.filter(i => i.Since == null);
              }

              this.loading = false;
            },
            error => {
              this.loading = false;
            }
          );
        }
      });
  }

  remove(record: ApiRecord) {

    let html: string = '';
    html += '<table class="table data-table-content" style="width: 100%">';
    html += '<thead>';
    html += '<tr>';
    html += '<td class="text-left">Cửa hàng</td>';
    html += '<td class="text-center">Ngày bắt đầu</td>';
    html += '<td class="text-center">Áp dụng lần cuối</td>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    html += '<tr>';
    html += '<td class="text-left">' + this.html(record.Address) + '</td>';
    html += '<td class="text-center text-primary">' + record.Since + '</td>';
    html += '<td class="text-center text-warning">' + (record.Last == null ? 'chưa áp dụng' : record.Last) + '</td>';
    html += '</tr>';
    html += '</tbody>';
    html += '</table>';

    let data: MessageBoxData = {
      buttons: [
        { name: 'Gỡ bỏ', class: 'ecg-bg-danger-dark' },
        { name: 'Bỏ qua', class: 'ecg-bg-warning-dark' }
      ],

      title: 'Xác nhận gỡ bỏ áp dụng phí',
      content: html
    };

    this.modal
      .show(MessageBoxComponent, { class: 'modal-md', initialState: { data: data } })
      .content.selected.subscribe(button => {

        if (button != data.buttons[0]) return;

        this.loading = true;

        this.api.feeRemove({ CapitalID: record.CapitalID, FeeID: record.FeeID }).subscribe(response => {

          if (response.succeed && response.data) {

            this.capitalLU[record.CapitalID].Since = null;

            this.appliedConfig.data = this.capitals.filter(i => i.Since != null);
            this.unAppliedConfig.data = this.capitals.filter(i => i.Since == null);
          }

          this.loading = false;
        });
      })
  }
}
